import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => navigator.serviceWorker.register("/sw.js").catch(() => {}));
}

fetch(`${process.env.REACT_APP_BACKEND_URL}/api/settings`).then((r) => r.json()).then((s) => {
  const base = `${process.env.REACT_APP_BACKEND_URL}/api/settings/icon`;
  const set = (sel, url) => { const el = document.querySelector(sel); if (el) el.href = url; };
  const v = (k) => encodeURIComponent(s.icons?.[k]?.updated_at || "");
  set('link[rel="icon"]', `${base}/favicon?size=64&v=${v("favicon")}`);
  set('link[rel="apple-touch-icon"]', `${base}/app_icon?size=180&v=${v("app_icon")}`);
}).catch(() => {});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
